module.exports = __webpack_public_path__ + "media/assets/images/blog/testing-061c3a5045773ed0c2a830d2d48c27d4.jpeg";